// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2[data-v-77f6d86d] {\n  fill: #fff\n}\n.st129[data-v-77f6d86d] {\n  fill: #80cf40\n}\n.st130[data-v-77f6d86d] {\n  fill: #a0db70\n}\n", ""]);
// Exports
module.exports = exports;
